import { useMutation, useQueryClient } from "react-query";
import { useSetRecoilState } from "recoil";
import { error_message, success_message } from '../../global_state'
import { deactivate_recruiter } from "../../services/admin";


const  useDeactivateRecruiter = () => {
  const queryClient = useQueryClient()
  const set_error = useSetRecoilState(error_message)
  const set_success = useSetRecoilState(success_message)

  return  useMutation((email)=>deactivate_recruiter(email), {
      onSuccess: data => {
        set_success('Successfully deactivated recruiter account!')
        setTimeout(() => {
          set_success('')
        }, 4000);
        queryClient.invalidateQueries('get_invitations')
      },
      onError: () => {
        set_error('Problem deactivating recruiter account!')
        setTimeout(() => {
          set_error('')
        }, 4000);
      }
  })
}

export default useDeactivateRecruiter;